import React from 'react';
import DENTButton from '../../../Base/Components/DENT/DENTButton/DENTButton';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalMobility.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import useTooth from '../../Hooks/Tooth/useTooth';
import { FURCATION_OPTIONS } from '../../Helpers/periodontal/furcationOptions';

const DENTModalOverviewPeriodontalFurcation = () => {
	const {
		periodontal: { getPeriodontal: periodontal, setFurcation },
	} = useTooth();
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<h5>{t('patientTreatment.meddiDENT.dentalCross.furcation.title')}</h5>
			<div className={styles.buttons}>
				{FURCATION_OPTIONS.map(option => (
					<DENTButton
						key={option.type}
						title={option.title}
						onClick={() => setFurcation(option.type)}
						isSelected={periodontal.furcation === option.type}
					/>
				))}
			</div>
		</div>
	);
};

export default DENTModalOverviewPeriodontalFurcation;
